(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const menuNavs = document.querySelectorAll('.full-menu[data-menu-id]');

    menuNavs.forEach(function(menuNav) {
      const expandBehavior = menuNav.getAttribute('data-expand-behavior');
      const toggleButtons = menuNav.querySelectorAll('.full-menu__toggle');

      toggleButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          const submenuId = this.getAttribute('aria-controls');
          const submenu = document.getElementById(submenuId);

          if (!submenu) return;

          if (expandBehavior === 'accordion') {
            const parentItem = this.closest('.full-menu__item');
            const siblingItems = Array.from(parentItem.parentElement.children).filter(function(child) {
              return child !== parentItem;
            });

            siblingItems.forEach(function(sibling) {
              const siblingToggle = sibling.querySelector('.full-menu__toggle');
              const siblingSubmenu = sibling.querySelector('.full-menu__sublist');
              if (siblingToggle && siblingSubmenu) {
                siblingToggle.setAttribute('aria-expanded', 'false');
                siblingSubmenu.setAttribute('hidden', '');
              }
            });
          }

          if (isExpanded) {
            this.setAttribute('aria-expanded', 'false');
            submenu.setAttribute('hidden', '');
          } else {
            this.setAttribute('aria-expanded', 'true');
            submenu.removeAttribute('hidden');
          }
        });

        button.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
              e.preventDefault();
              const submenuId = this.getAttribute('aria-controls');
              const submenu = document.getElementById(submenuId);
              this.setAttribute('aria-expanded', 'false');
              if (submenu) submenu.setAttribute('hidden', '');
              this.focus();
            }
          }
        });
      });

      if (window.matchMedia('(min-width: 990px)').matches) {
        const layoutStyle = menuNav.classList.contains('full-menu--horizontal');
        if (layoutStyle) {
          const level1Items = menuNav.querySelectorAll('.full-menu__item--level-1');
          level1Items.forEach(function(item) {
            const submenu = item.querySelector('.full-menu__sublist--level-2');
            if (submenu) {
              item.addEventListener('mouseenter', function() {
                submenu.removeAttribute('hidden');
              });
              item.addEventListener('mouseleave', function() {
                submenu.setAttribute('hidden', '');
              });
            }
          });

          const level2Items = menuNav.querySelectorAll('.full-menu__item--level-2');
          level2Items.forEach(function(item) {
            const submenu = item.querySelector('.full-menu__sublist--level-3');
            if (submenu) {
              item.addEventListener('mouseenter', function() {
                submenu.removeAttribute('hidden');
              });
              item.addEventListener('mouseleave', function() {
                submenu.setAttribute('hidden', '');
              });
            }
          });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
